import { FunctionComponent, ReactFragment } from 'react';
import { Close, Person } from '../icons';
import { Typography, IconButton, Paper } from '../../tailwindcomponents';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import ProfileImg from '../Images/ProfileImg';

type CollectionProps = {
    collectionList: any[],
    removeItem: Function,
    nameProperty?: string,
    idProperty?: string,
    title: string,
    iconFallback?: ReactFragment,
    rows?: 1 | 2
    background?: boolean,
    edit?: boolean,
}

const Collection: FunctionComponent<CollectionProps> = ({ collectionList, title, edit = true, removeItem, nameProperty = "name", idProperty = "id", rows = 2, iconFallback = <Person />, background = true }) => {
    const users = useSelector((state: RootState) => state.employees.all_employees);

    // ProfileImg resolves its picture from the image store by userName, so the item has
    // to be mapped to a user first. Items arrive in two shapes: already a `User` (the
    // handover and flight-schedule lists) or a domain row keyed by an employee id (task
    // labour). This used to be hardcoded as `s.Id === item.id`, which silently resolved
    // to undefined for every call site whose id lives under `idProperty` - i.e. all of
    // them - so the avatar rendered with an empty src. Match on whichever key the item
    // actually carries.
    const resolveUserName = (item: any): string | undefined => {
        if (typeof item.userName === 'string') return item.userName.split('@')[0];
        const key = item[idProperty];
        const user = users?.find(s => s.Id === key || s.user_id === key);
        return user?.userName?.split('@')[0];
    };
    return (
        // A recessed container holding raised chips. The outer surface used to be
        // `--ds-border` — a hairline token pressed into service as a fill — with
        // asymmetric `pt-4 pb-10`; it is now the proper sunken surface with even
        // padding. Items were a solid blue pill with white text at radius 25;
        // they are now soft accent chips on the design system's radius.
        <div
            className={[
                'flex flex-wrap w-full items-start gap-2 mb-4 p-2 rounded-[var(--ds-r-lg)]',
                background ? 'bg-[color:var(--ds-surface-sunken)] border border-solid border-line text-content' : '',
            ].join(' ')}
        >
            <div className="w-full">
                <Typography align="center" color="textPrimary" text={title} variant="h4"></Typography>
            </div>
            {collectionList.map((item, idx) => (
                <div key={idx} className={rows === 2 ? "w-[calc(50%-0.25rem)]" : "w-full"} >
                    <Paper
                        className="flex items-center gap-2 pr-1 border border-solid border-line"
                        elevation={0}
                        style={{
                            backgroundColor: 'var(--ds-accent-soft)',
                            color: 'var(--ds-accent-text)',
                            borderRadius: 'var(--ds-r-md)',
                        }}
                    >
                        <ProfileImg imgKey={idx} userName={resolveUserName(item)} fallback={iconFallback} />
                        <Typography align="left" variant="body2" text={item[nameProperty]}></Typography>

                        {edit === true && (
                            <IconButton size="small" className="ml-auto" onClick={() => removeItem(item[idProperty])}><Close /> </IconButton>
                        )}
                    </Paper>
                </div>
            ))}
        </div>
    );
};
export default Collection